import { render, staticRenderFns } from "./JLabels.vue?vue&type=template&id=0b7296ef&scoped=true&"
import script from "./JLabels.vue?vue&type=script&lang=js&"
export * from "./JLabels.vue?vue&type=script&lang=js&"
import style0 from "./JLabels.vue?vue&type=style&index=0&id=0b7296ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7296ef",
  null
  
)

export default component.exports